module.exports = __webpack_public_path__ + "media/images/icons/adidas-logo-ca20bc26b09f1ce5223b3cd76955c0c8.svg";